<template>
  <div>
    <div class="hoge" :style="containerStyle">
      <div class="rankingView_list" v-if="shouldShowRankers">
        <div class="ranking_topThreeContainer">
          <ranking-top-three-cell
            v-for="(result, idx) in topThree()"
            :key="idx"
            :result="result"
            :isFirst="idx === 1"
          ></ranking-top-three-cell>
        </div>
        <div class="ranking_rankerContainer">
          <ranking-cell
            v-for="(result, idx) in fourOrLess()"
            :key="idx"
            :result="result"
          ></ranking-cell>
        </div>
      </div>
      <div class="rankingView__empty" v-if="shouldShowEmpty">
        <div>
          <p style="color: #188dff; font-size: 14px">
            {{ $t('noRankingData') }}
          </p>
        </div>
        <div style="font-size: 12px">
          <p>{{ $t('audienceRankingDesc1') }}</p>
          <p>{{ $t('audienceRankingDesc2') }}</p>
        </div>
      </div>
    </div>
    <ranking-cell
      v-if="data.mydata !== undefined"
      class="rankingView__myDatra"
      :result="data.mydata"
    ></ranking-cell>
  </div>
</template>

<script>
import RankingCell from '@/components/AudienceRanking/RankingCell.vue'
import RankingTopThreeCell from '@/components/AudienceRanking/RankingTopThreeCell.vue'
export default {
  name: 'RankingView',
  components: {
    RankingCell,
    RankingTopThreeCell,
  },
  props: {
    data: {
      ranking_type: Number,
      rankers: Array,
      myData: {
        type: Object,
        required: false,
      },
    },
  },
  data: function () {
    return {
      height: '0px',
    }
  },
  computed: {
    shouldShowRankers() {
      // TODO: nullレスポンスが入らない仕様になったら修正
      if (this.data.rankers === null) {
        return false
      }

      return this.data.rankers.length > 0
    },
    shouldShowEmpty() {
      if (this.data.rankers === null) {
        return true
      }

      // TODO: nullレスポンスが入らない仕様になったら修正
      return this.data.rankers.length === 0
    },
    containerStyle() {
      return {
        height: `${this.height}px`,
        overflow: 'scroll',
        '-webkit-overflow-scrolling': 'touch',
      }
    },
  },
  mounted() {
    const headerHeight = this.$route.query.tp === 'avatar' ? 0 : 38
    const descriptionHeight = 19
    const tabViewHeight = 40
    const footerHeight = this.$route.query.av !== undefined ? 60 : 0

    this.height =
      window.innerHeight -
      headerHeight -
      descriptionHeight -
      tabViewHeight -
      footerHeight
  },
  methods: {
    topThree: function () {
      var filtered = this.data.rankers.filter((ranker) => ranker.rank <= 3)
      if (filtered.length > 3) {
        filtered = filtered.slice(0, 3)
      }

      if (filtered.length === 1) {
        return [
          {
            rank: 2,
          },
          filtered[0],
          {
            rank: 3,
          },
        ]
      }

      if (filtered.length === 2) {
        return [
          filtered[1],
          filtered[0],
          {
            rank: 3,
          },
        ]
      }

      if (filtered.length === 3) {
        return [filtered[1], filtered[0], filtered[2]]
      }

      return filtered
    },
    fourOrLess: function () {
      if (this.data.rankers.length < 4) {
        return []
      }

      return this.data.rankers.slice(3)
    },
  },
}
</script>

<style scoped>
.ranking_topThreeContainer {
  display: flex;
  justify-content: space-around;
  height: 188px;
  border-bottom: 1px solid #eeeeee;
}

.rankingView__myDatra {
  bottom: 0;
  left: 0;
  width: 100%;
  background-color: white;
  border-top: 1px solid #eee;
}

.rankingView__empty {
  text-align: center;
}

.rankingView__empty div {
  margin: 10px;
}
</style>
